import { useContext } from 'react';
import {
  ApiFilterOperation,
  HookedSource,
  UserContext,
  useScrollableSource,
} from '@eas/common-web';
import { Team } from '@models';
import { EvidenceApiUrl, Permission } from '@enums';

export const USERS_SOURCE = 'USERS_SOURCE';
export const DEPARTMENTS_SOURCE = 'DEPARTMENTS_SOURCE';

function useUserSource(): HookedSource<Team> {
  const source = useScrollableSource();
  const { hasPermission } = useContext(UserContext);

  return {
    [USERS_SOURCE]: {
      source,
      shouldLoad: () => hasPermission(Permission.USER_LIST),
      modifyBeforeLoad: ({ id }) => {
        source.setUrl(`${EvidenceApiUrl.USERS}/list`);
        source.setParams({
          size: 15,
          filters: [
            {
              field: 'team.id',
              operation: ApiFilterOperation.EQ,
              value: id,
            },
          ],
        });
      },
    },
  };
}

function useDepartmentSource(): HookedSource<Team> {
  const source = useScrollableSource();
  const { hasPermission } = useContext(UserContext);

  return {
    [DEPARTMENTS_SOURCE]: {
      source,
      shouldLoad: () => hasPermission(Permission.DEPARTMENT_LIST),
      modifyBeforeLoad: ({ id }) => {
        source.setUrl(`${EvidenceApiUrl.DEPARTMENTS}/list`);
        source.setParams({
          size: 15,
          filters: [
            {
              operation: ApiFilterOperation.AND,
              filters: [
                {
                  field: 'team.id',
                  operation: ApiFilterOperation.EQ,
                  value: id,
                },
                {
                  field: 'active',
                  operation: ApiFilterOperation.EQ,
                  value: true,
                },
              ],
            },
          ],
        });
      },
    },
  };
}

export function useTeamHookedSources(): HookedSource<Team> {
  const departments = useDepartmentSource();
  const users = useUserSource();

  return { ...users, ...departments };
}
